// PaginationList
const DEFAULT_ARIA_LABEL = "Pagination";
const getDefaultPageBtnAriaLabel = page => `Page ${page}`;
const NEXT_LABEL_DEFAULT = "Next";
const PREV_LABEL_DEFAULT = "Prev";

// PaginationPerPageSelect
const PER_PAGE_SELECT_BEFORE_LABEL_DEFAULT = "Showing";
const setPerPageSelectAfterLabelDefault = totalItems => `of ${totalItems}`;
const setSelectAriaLabelDefault = _ref => {
  let {
    totalItems,
    itemsPerPage
  } = _ref;
  return `Showing ${itemsPerPage} of ${totalItems}`;
};

// PaginationGoTo
const GO_BTN_LABEL_DEFAULT = "Go";
const GOTO_BEFORE_LABEL_DEFAULT = "Go to page";
const GOTO_ONLY_BEFORE_LABEL_DEFAULT = "Page";
const setGotoAfterLabelDefault = totalPages => `/${totalPages}`;
const setPageInputAriaLabelDefault = totalPages => `Go to page of ${totalPages}`;

export { DEFAULT_ARIA_LABEL, GOTO_BEFORE_LABEL_DEFAULT, GOTO_ONLY_BEFORE_LABEL_DEFAULT, GO_BTN_LABEL_DEFAULT, NEXT_LABEL_DEFAULT, PER_PAGE_SELECT_BEFORE_LABEL_DEFAULT, PREV_LABEL_DEFAULT, getDefaultPageBtnAriaLabel, setGotoAfterLabelDefault, setPageInputAriaLabelDefault, setPerPageSelectAfterLabelDefault, setSelectAriaLabelDefault };
